import { HttpParams, HttpStatusCode } from '@angular/common/http';

/**
 * Constructs an HttpParams object from a given object.
 * @param object The object to be converted into HttpParams.
 * @returns { HttpParams } An instance of HttpParams containing the parameters from the object.
 */

export function buildParamsFromObject(object?: any): HttpParams {
  let params = new HttpParams();

  if (object) {
    for (const [key, value] of Object.entries(object)) {
      if (value != null && value !== undefined) {
        if (Array.isArray(value)) {
          value.map((opts) => {
            params = params.append(key, opts.toString());
          });
        } else {
          params = params.append(key, value.toString());
        }
      }
    }
  }

  return params;
}
